const nav = document.querySelector('.symptom-nav_hero');
const container = document.querySelector('.symptom-nav_hero_container');
const prev = document.querySelector('.symptom-nav_hero_container .prev');
const next = document.querySelector('.symptom-nav_hero_container .next');
const firstCard = document.querySelector('.symptom-nav_hero li');
const allCards = document.querySelectorAll('.symptom-nav_hero li');

let leftTimer = -1;
let rightTimer = -1;

if(firstCard.offsetWidth * allCards.length > nav.offsetWidth) {
	container.classList.add('right-arrow');
}

nav.addEventListener('scroll', (event) => {
	if(leftTimer !== -1) {
		clearTimeout(leftTimer);
	}
	if(rightTimer !== -1) {
		clearTimeout(rightTimer);
	}
	
	leftTimer = setTimeout(() => {
		if(nav.scrollLeft > 100) {
			container.classList.add('left-arrow');
		} else {
			container.classList.remove('left-arrow');
		}
	}, 200);

	rightTimer = setTimeout(() => {
		if(nav.scrollLeft < nav.scrollWidth - nav.offsetWidth - 30) {
			container.classList.add('right-arrow');
		} else {
			container.classList.remove('right-arrow');
		}
	}, 200);

});

next.addEventListener('click', (event) => {
	scrollElement(nav, firstCard.offsetWidth);
});

prev.addEventListener('click', (event) => {
	scrollElement(nav, firstCard.offsetWidth * -1);
});

function scrollElement(element, amount) {
	element.scrollBy({
		left: amount,
		top: 0,
		behavior: 'smooth'
	});
}

/*=============================
=        Sticky Section       =
=============================*/

[].slice.call(document.querySelectorAll('section.text_sticky_media')).forEach(function(section) {
	function detectIntersection(entries) {
		for (var e of entries) {
			var position = e.target.dataset.position;
			if(e.isIntersecting) {
				window.requestAnimationFrame(callback => {
					section.querySelector(`figure[data-position='${position}']`).classList.add('visible');
				});
			} else {
				section.querySelector(`figure[data-position='${position}']`).classList.remove('visible');
			}
		}
	}

	var observer = new IntersectionObserver(detectIntersection, {threshold: 0.25});

	section.querySelectorAll('.sticky_section_copy').forEach(function(copySection) {
		// observer.observe(copySection);
		var position = copySection.dataset.position;
		section.querySelector(`figure[data-position='0']`).classList.add('visible');

		new Waypoint({
			element: copySection,
			handler: function(direction) {
				window.requestAnimationFrame(callback => {
					if(direction == 'down' && position !== '0') {
						section.querySelector(`figure[data-position='${position}']`).classList.add('visible');
					} else if (direction == 'up' && position !== '0') {
						section.querySelector(`figure[data-position='${position}']`).classList.remove('visible');
					}
				});
			},
			offset: 320
		});
	});
});

// Load first image
const images = document.querySelectorAll('aside.sticky_section_right');

for (var i = 1; i >= 0; i--) {
	if(images[i]) {
		imgLazyload(images[i].querySelector('img'));
	}
}

/*=============================
=      Sticky Symptom Nav     =
=============================*/

window.scrollToElement = function scrollToElement(scrollTo) {
	if (document.querySelector('body').classList.contains('mobile')) {
		window.scrollBy(0, -120);
	} 
};

var stickyNav = document.querySelector('nav.symptom-nav');

if(stickyNav) {
	if ( document.querySelector('body').classList.contains('mobile')) {
		new Waypoint({
			element: document.querySelector('main'),
			handler: function(direction) {
				if(direction == 'down') {
					stickyNav.classList.add('show');
				} else {
					if(!stickyNav.classList.contains('open')) {
						stickyNav.classList.remove('show');
					}
				}
			},
			offset: 120
		});
	} else {
		new Waypoint({
			element: document.querySelector('main'),
			handler: function(direction) {
				if(direction == 'down') {
					stickyNav.classList.add('show');
				} else {
					if(!stickyNav.classList.contains('open')) {
						stickyNav.classList.remove('show');
					}
				}
			},
			offset: 150
		});
	}

	stickyNav.querySelector('.symptom-nav_heading').addEventListener('touchend', (event) => {
		stickyNav.classList.toggle('open');
		document.querySelector('body').classList.toggle('unscrollable');

	});

	document.querySelector('.symptom-nav').addEventListener('mouseover', (event) => {
		stickyNav.classList.add('open');
		document.querySelector('body').classList.add('unscrollable');
	});

	document.querySelector('.symptom-nav').addEventListener('mouseleave', (event) => {
		stickyNav.classList.remove('open');
		document.querySelector('body').classList.remove('unscrollable');
	});
}

// Close the sticky nav when a click outside is detected
window.addEventListener('click', (event) => {
	if(!stickyNav.contains(event.target)) {
		stickyNav.classList.remove('open');
		document.querySelector('body').classList.remove('unscrollable');
	}
});
